<template>
  <div class="w-100">
    <div
      class="flex justify-between items-center h-14 min-h-[3.5rem] px-4 py-2 bg-white dark:bg-slate-900 border-b border-slate-50 dark:border-slate-800/50"
    >
      <div class="flex w-100">
        <div class="flex pipeline w-[30%]">
          <div class="back-icon" @click="backUrl">
            <fluent-icon
              v-tooltip="'Back'"
              icon="back"
              :viewBox="'0 0 52 52'"
              size="14"
              class="mt-0.5 grey-color"
            />
          </div>
          <div class="pipeline-heading" >
            {{ boardName() }}
          </div>
        </div>
        <div class="searching-filter w-[70%]">
          <div class="flex filter-box">
            <div class="assignee cursor-pointer">
              <div
                v-if="!showAssignee && currentAssigneedata.id"
                class="assignee-img"
              >
                <thumbnail
                  :key="currentAssigneedata.id"
                  :src="currentAssigneedata.src"
                  :variant="'circle'"
                  :username="currentAssigneedata.name"
                  class="user-thumbnail"
                  size="35px"
                />
              </div>
              <div
                v-if="showAssignee && assigneedata.length > 0"
                class="absolute assignee-image"
              >
                <assignee-image :assignees="assigneedata" />
              </div>
              <div
                @click="openAssignee"
                class="assignee-user"
                :title="'Search Assignee'"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="39.643"
                  height="35.503"
                  viewBox="0 0 39.643 41.503"
                >
                  <g
                    id="Group_9625"
                    data-name="Group 9625"
                    transform="translate(-1492 -196)"
                  >
                    <g
                      id="Component_157_3"
                      data-name="Component 157 – 3"
                      transform="translate(1492 196)"
                    >
                      <ellipse
                        id="Ellipse_250"
                        data-name="Ellipse 250"
                        cx="19.321"
                        cy="19.172"
                        rx="19.321"
                        ry="19.172"
                        transform="translate(1 2)"
                        fill="#fff"
                      />
                      <path
                        id="c8fbea57a3a6be7d76ca3fedfe3d9d12"
                        d="M20.478,2A19.424,19.424,0,0,0,1,21.329,19.125,19.125,0,0,0,6.7,35,19.4,19.4,0,1,0,20.478,2ZM8.7,34.871a14.71,14.71,0,0,1,11.4-5.685c.069,0,.135.02.2.02h.066c.063,0,.121-.017.184-.02a14.687,14.687,0,0,1,11.5,5.848A18.078,18.078,0,0,1,8.7,34.871Zm11.613-7.128c-.072,0-.141.011-.213.014a6.451,6.451,0,1,1,.458,0c-.081,0-.161-.017-.245-.017Zm12.808,6.331a16.121,16.121,0,0,0-8.975-5.865,7.8,7.8,0,0,0,1.771-12.444,7.976,7.976,0,0,0-11.206.049,7.8,7.8,0,0,0,1.8,12.39,16.146,16.146,0,0,0-8.874,5.7,17.708,17.708,0,0,1-5.2-12.57,18.039,18.039,0,0,1,36.077,0,17.787,17.787,0,0,1-5.395,12.739Z"
                        transform="translate(-0.727 0.844)"
                        fill="#989898"
                      />
                      <g
                        id="Ellipse_248"
                        data-name="Ellipse 248"
                        transform="translate(0 3)"
                        fill="none"
                        stroke="#e1e1e1"
                        stroke-width="2"
                      >
                        <ellipse
                          cx="19.821"
                          cy="19.172"
                          rx="19.821"
                          ry="19.172"
                          stroke="none"
                        />
                        <ellipse
                          cx="19.821"
                          cy="19.172"
                          rx="18.821"
                          ry="18.172"
                          fill="none"
                        />
                      </g>
                      <g
                        id="Group_9623"
                        data-name="Group 9623"
                        transform="translate(21.643)"
                      >
                        <circle
                          id="Ellipse_249"
                          data-name="Ellipse 249"
                          cx="9"
                          cy="9"
                          r="9"
                          fill="#fff"
                        />
                        <g
                          id="df97f3f320e4be9a323ac0d1109bc0c9"
                          transform="translate(4.986 4.986)"
                        >
                          <path
                            id="Path_2255"
                            data-name="Path 2255"
                            d="M14.5,15.025V7"
                            transform="translate(-10.487 -7)"
                            fill="none"
                            stroke="#989898"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                          <path
                            id="Path_2256"
                            data-name="Path 2256"
                            d="M7,14.5h8.025"
                            transform="translate(-7 -10.487)"
                            fill="none"
                            stroke="#989898"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div
                v-if="showAssignee && assigneedata.length > 0"
                class="assignee-list"
              >
                <assignee-list
                  :assignees="assigneedata"
                  @close="toggleAssignee"
                  :currentassignee="currentAssignee"
                  v-on-clickaway="hideAssignee"
                />
              </div>
              <div
                v-if="showAssignee && assigneedata.length == 0"
                class="assignee-list empty-assignee"
              >
                {{ $t('SIDEBAR.EMPTY_ASSIGNEE') }}
              </div>
            </div>
            <!-- <div class="state-input filter-text">
              <select
                @change="handleDropdownBoard"
                v-model="selectedBoard"
                class="pipeline-dropdown new-color"
              >
                <option value="">{{ $t('PIPELINES.BOARD') }}</option>
                <option
                  v-for="board in boards"
                  :key="board.name"
                  :value="board.id"
                >
                  {{ board.name }}
                </option>
                <option value="add-more-board" class="add-more-option">
                  {{ $t('PIPELINES.ADD_MORE_BOARD') }}
                </option>
              </select>
              <add-more-board :show="showMoreBoard" @close="hideMoreboard" />
            </div> -->

            <div>
              <source-lead-dropdown
                :leads="inboxesWithAll"
                placeholder="Source of Lead"
                :open="openDropdown === 'leads'"
                @input="handleDropdownLead"
                @addMore="handleDropdownLead"
                @toggle="toggleDropdown('leads')"
              />
            </div>

            <!-- <div>
              <CustomDropdown
                :boards="boards"
                placeholder="Board"
                addMoreLabel="Add More Board"
                :open="openDropdown === 'board'"
                @input="handleDropdownBoard"
                @addMore="handleDropdownBoard"
                @toggle="toggleDropdown('board')"
              />
              <add-more-board :show="showMoreBoard" @close="hideMoreboard" />
            </div> -->

            <div>
              <SelectState
                :states="states"
                placeholder="State"
                addMoreLabel="Add More State"
                :open="openDropdown === 'state'"
                @input="handleDropdownChange"
                @addMore="handleDropdownChange"
                @toggle="toggleDropdown('state')"
              />
              <add-more-state :show="showMoreState" @close="hideMorestate" />
            </div>

            <div>
              <!-- <p>Selected Date Range: {{ customDate }}</p> -->
              <date-dropdown
                :dateOptions="dateOptions"
                :placeholder="customDate || 'Date'"
                :customDate="customDate || 'Date'"
                :open="openDropdown === 'date'"
                @input="onRangeChange"
                @addMore="onRangeChange"
                @toggle="toggleDropdown('date')"
              />

              <AddCustomDate
                :show="showCustomDate"
                @close="toggleCustomDate"
                @update-date="onDateUpdate"
              />
            </div>
            <div
              class="flex items-center relative mr-2 search-wrap input-search"
            >
              <input
                type="text"
                :placeholder="'Search Lead by Name, Phone, Email Id'"
                class="contact-search border-slate-100 dark:border-slate-600"
                v-model.trim="searchQuery"
                @keyup.enter="filterbyinput"
              />
              <div class="search-icon-data">
                <fluent-icon
                  icon="search"
                  class="dark:bg-slate-900 dark:text-slate-200 h-5 leading-9 text-slate-700 text-sm"
                />
              </div>
              <!-- <woot-button
                :is-loading="false"
                class="clear"
                :class-names="searchButtonClass"
                @click="filterbyinput"
              >
                {{ $t('CONTACTS_PAGE.SEARCH_BUTTON') }}
              </woot-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="h-full">
      <div class="pipeline-container">
        <new-pipeline
          ref="newPipeline"
          @contact-count-updated="updateLeadCount"
        />
      </div>
    </div>
    <footer class="w-full bg-white  p-2  fixed bottom-0 left-0 border-t border-[rgb(236,238,240)] text-[rgb(60,72,88)] flex items-center px-4">
      <div class="mx-[3.7rem] flex-1 text-left text-[12px]">Total Lead: <span  class="font-bold">{{ totalLeadCount }}</span> </div>
    </footer>
  </div>
</template>

<script>
import AddCustomDate from './AddCustomDate.vue';
import AssigneeList from './AssigneeList.vue';
import AddMoreState from './AddMoreState.vue';
import NewPipeline from './NewPipeline.vue';
import { mapGetters } from 'vuex';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import AddMoreBoard from './AddMoreBoards.vue';
import Thumbnail from '../../../../components/widgets/Thumbnail.vue';
import { mixin as clickaway } from 'vue-clickaway';
import CustomDropdown from './CustomDropdown.vue';
import SelectState from './StateDropdown.vue';
import DateDropdown from './DateDropdown.vue';
import SourceLeadDropdown from './SourceLeadDropdown.vue';
import AssigneeImage from './indexSearching/AssigneeImage.vue';
import alertMixin from 'shared/mixins/alertMixin';
export default {
  components: {
    AddCustomDate,
    AssigneeList,
    NewPipeline,
    AddMoreState,
    LoadingState,
    AddMoreBoard,
    Thumbnail,
    CustomDropdown,
    SelectState,
    DateDropdown,
    SourceLeadDropdown,
    AssigneeImage,
  },
  data() {
    return {
      showCustomDateModal: true, // Controls the modal visibility
      customDate: '', // Holds the selected custom date range
      scheduledAtFrom: null,
      scheduledAtTo: null,
      openDropdown: null,
      selectedState: '',
      selectedSource: '',
      searchQuery: '',
      selectedRange: '',
      showCustomDate: false,
      enabled: false,
      showMoreState: false,
      selectedBoard: '',
      showMoreBoard: false,
      src: 'data:image/jpeg;base64,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',
      showAssignee: false,
      currentAssignee: null,
      filterMonths: '',
      currentAssigneedata: {},
      dateOptions: [
        {
          id: '',
          name: this.$t('PIPELINES.ALL'),
          value: 'all',
        },
        {
          id: 1,
          name: this.$t('PIPELINES.Last_Week'),
          value: 'last week',
        },
        {
          id: 2,
          name: this.$t('PIPELINES.Last_Month'),
          value: 'last month',
        },
        {
          id: 3,
          name: this.$t('PIPELINES.Last_6_Month'),
          value: 'last six months',
        },
        {
          id: 4,
          name: this.$t('PIPELINES.CUSTOM_DATE'),
          value: 'custom',
        },
      ],
      totalLeadCount: 0,
    };
  },
  mixins: [alertMixin,clickaway],
  watch: {
    searchQuery(newVal) {
      if (newVal.length == 0) {
        let data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
        };

        // Normalize filterMonths value (e.g., replacing spaces with underscores)
        const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

        if (normalizedFilter) {
          switch (normalizedFilter) {
            case 'all':
              data.key2 = 'all';
              data.value2 = this.filterMonths;
              break;
            case 'last_week':
              data.key2 = 'last_week';
              data.value2 = this.filterMonths;
              break;
            case 'last_month':
              data.key2 = 'last_month';
              data.value2 = this.filterMonths;
              break;
            case 'last_six_months':
              data.key2 = 'last_six_months';
              data.value2 = this.filterMonths;
              break;
            default:
              console.warn('Unknown filterMonths value:', this.filterMonths);
              break;
          }
        } else {
          data.key2 = 'start_date';
          data.value2 = this.scheduledAtFrom; // The start date filter
          data.key3 = 'end_date';
          data.value3 = this.scheduledAtTo; // The end date filter
        }
        this.$store.dispatch('pipelines/FilterContact', data);
      }
    },
    selectedBoard(newBoard) {
      if (newBoard && typeof newBoard === 'number') {
        this.$router.replace({
          name: 'pipeline_boards',
          params: { board_id: newBoard },
        });
      }
    },
    '$route.params.board_id'(newBoardId, oldBoardId){
      if(newBoardId !== oldBoardId){
        this.selectedBoard = newBoardId;
      }
    },
    '$route.params.board_id'(newBoardId, oldBoardId) {
      if (newBoardId !== oldBoardId) {
         this.selectedBoard = newBoardId;
         document.title = `${this.boardName()} | Kivo`; // ✅ Update title here
      }
},
  // Also watch for boards data to be loaded
  boards: {
    handler() {
      document.title = `${this.boardName()} | Kivo`;
    },
    immediate: true
  },
  },
  mounted() {
    const boardId = this.$route.params.board_id;
    this.selectedBoard = boardId
    this.$store.dispatch('pipelines/getState');
    this.$store.dispatch('pipelines/getBoards');
    this.$store.dispatch('pipelines/getAssignee');
    this.$root.$on('contact-count-updated', this.updateLeadCount);
    bus.$on('toggle-pipeline-dropdown-dragging', this.closeAlldraggable);
    bus.$on('dropdown-data', this.setSearchNull);
    bus.$on('dropdown-data', this.setDropdownNull);
    bus.$on('reset-date-dropdown', () => {
      this.customDate = ''; // Reset custom date
    });
    console.log('My Inboxes', this.inboxes);
    document.title = `${this.boardName()} | Kivo`;
    this.updateLeadCount();
  },
  beforeDestroy() {
    this.$root.$off('contact-count-updated', this.updateLeadCount);
    bus.$off('reset-date-dropdown'); // Cleanup event listener
  },
  computed: {
    ...mapGetters({
      uiFlags: 'pipelines/getUIFlags',
      inboxes: 'inboxes/getInboxes',
    }),
    states() {
      // return this.$store.getters['pipelines/getAllStatus'];
      return [
        { id: '', name: 'All' },
        ...this.$store.getters['pipelines/getAllStatus'],
      ];
    },
    inboxesWithAll() {
      return [{ id: '', name: 'All' }, ...this.inboxes];
    },
    boards() {
      const apiBoards = this.$store.getters['pipelines/getAllBoards'] || [];

      // Filter out any board named "Default Board" with an id
      const filteredBoards = apiBoards.filter(
        board => !(board.name === 'Default Board' && board.id)
      );

      // Add your intended default board manually (id: '')
      return [{ id: '', name: 'Default Board' }, ...filteredBoards];
    },
    searchButtonClass() {
      return this.searchQuery !== '' ? 'show' : '';
    },
    assigneedata() {
      return [
        { id: '', name: 'Deselect' },
        ...this.$store.getters['pipelines/getAllAssignee'],
      ];
    },
  },
  methods: {
    onCustomDateSelected({ scheduledAtFrom, scheduledAtTo }) {
      // this.customDate = dateRange; // Update the custom date range
      // this.showCustomDateModal = false; // Close modal
      const formattedFrom = this.formatDate(scheduledAtFrom);
      const formattedTo = this.formatDate(scheduledAtTo);
      // Prepare the data object with the formatted dates and filters
      const data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key2: 'start_date',
        value2: this.scheduledAtFrom, // The formatted start date
        key3: 'end_date',
        value3: this.scheduledAtTo, // The formatted end date
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
      };

      console.log('Date with filters:', data); // Log the final data object

      // Dispatch the store action with the prepared data
      this.$store.dispatch('pipelines/FilterContact', data);
      // Format the string for display
      this.customDate = `${formattedFrom} to ${formattedTo}`;
      console.log('Updated Custom Date:', this.customDate); // Debugging
    },
    setSearchNull() {
      this.searchQuery = '';
    },
    handleDropdownChange(selectedId) {
      this.selectedState = selectedId;
      console.log('Selected State:', this.selectedState);
      if (this.selectedState == 'add-more') {
        this.showMoreState = true;
      } else if (this.selectedState != 'add-more') {
        this.callApi(this.selectedState);
      }
    },

    handleDropdownLead(selectedId) {
      this.selectedSource = selectedId;
      console.log('Selected State:', this.selectedSource);
      this.callApiLead(this.selectedSource);
    },

    // handleDropdownBoard(selectedId) {
    //   this.selectedBoard = selectedId;
    //   console.log('Selected Boards:', this.selectedBoard);
    //   // this.$store.dispatch('pipelines/getBoards');
    //   if (this.selectedBoard == 'add-more-board') {
    //     this.showMoreBoard = true;
    //   } else if (this.selectedBoard != 'add-more') {
    //     this.callApiboard(this.selectedBoard);
    //   }
    // },
    handleDropdownBoard(selectedId) {
      this.selectedBoard = selectedId;
      console.log('Selected Boards:', this.selectedBoard);

      if (this.selectedBoard === 'add-more-board') {
        this.showMoreBoard = true;
      } else if (this.selectedBoard === '') {
        // "All" selected — navigate to default pipeline route
        if (this.$route.name !== 'pipeline') {
          this.$router.push({ name: 'pipeline' });
        }
        this.callApiboard(this.selectedBoard);
      } else if (this.selectedBoard !== 'add-more') {
        this.callApiboard(this.selectedBoard);
      }
    },

    callApi(selectedState) {
      console.log(`Making API call with state: ${selectedState}`);
      this.selectedState = selectedState;
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
      };

      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    callApiLead(selectedSource) {
      console.log(`Making API call with state: ${selectedSource}`);
      this.selectedSource = selectedSource;
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
      };

      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    callApiboard(selectedBoard) {
      console.log(`Making API call with state: ${selectedBoard}`);
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
      };

      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'all':
            data.key2 = 'all';
            data.value2 = this.filterMonths;
            break;
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    onDateChange(value) {
      console.log('My Date:', value);
      this.scheduledAt = value;
      this.$store.dispatch('pipelines/create', { value });
    },
    filterbyinput() {
      const validSearch = /[a-zA-Z0-9]/.test(this.searchQuery);
      if (this.searchQuery && validSearch) {
        let data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
        };

        // Normalize filterMonths value (e.g., replacing spaces with underscores)
        const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

        if (normalizedFilter) {
          switch (normalizedFilter) {
            case 'all':
              data.key2 = 'all';
              data.value2 = this.filterMonths;
              break;
            case 'last_week':
              data.key2 = 'last_week';
              data.value2 = this.filterMonths;
              break;
            case 'last_month':
              data.key2 = 'last_month';
              data.value2 = this.filterMonths;
              break;
            case 'last_six_months':
              data.key2 = 'last_six_months';
              data.value2 = this.filterMonths;
              break;
            default:
              console.warn('Unknown filterMonths value:', this.filterMonths);
              break;
          }
        } else {
          data.key2 = 'start_date';
          data.value2 = this.scheduledAtFrom; // The start date filter
          data.key3 = 'end_date';
          data.value3 = this.scheduledAtTo; // The end date filter
        }
        this.$store.dispatch('pipelines/FilterContact', data);   
    }else {
        this.showAlert('Please enter a valid search term.');
      }
    },
    async getallstate() {
      const data = await this.$store.dispatch('pipelines/getstate');
      console.log('Response', data);
    },
    onRangeChange(selectedId) {
      this.selectedRange = selectedId;
      if (this.selectedRange !== 'custom') {
        this.setScheduledDate(this.selectedRange);
        this.showCustomDate = false;
      } else {
        // Open modal for custom date selection
        this.showCustomDate = true;
      }
    },
    setScheduledDate(monthsBefore) {
      console.log('Months Before', monthsBefore);
      // const date = new Date();
      // date.setMonth(date.getMonth() - parseInt(monthsBefore, 10)); // Calculate date months before
      // this.scheduledAt = date.toISOString().slice(0, 10); // Set the formatted date
      if (monthsBefore == 'all') {
        this.filterMonths = 'all';
        const data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key2: 'all',
          value2: this.filterMonths,
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
        };
        this.$store.dispatch('pipelines/FilterContact', data);
      }
      if (monthsBefore == 'last week') {
        this.filterMonths = 'last week';
        const data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key2: 'last_week',
          value2: this.filterMonths,
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
        };
        this.$store.dispatch('pipelines/FilterContact', data);
      }
      if (monthsBefore == 'last month') {
        this.filterMonths = 'last month';
        const data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key2: 'last_month',
          value2: this.filterMonths,
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
        };
        this.$store.dispatch('pipelines/FilterContact', data);
      }
      if (monthsBefore == 'last six months') {
        this.filterMonths = 'last six months';
        const data = {
          key: 'state_id',
          value: this.selectedState, // The state filter
          key1: 'name',
          value1: this.searchQuery, // The name filter
          key2: 'last_six_months',
          value2: this.filterMonths,
          key4: 'board_id',
          value4: this.selectedBoard,
          key5: 'assignee_id',
          value5: this.currentAssignee,
          key6: 'source_id',
          value6: this.selectedSource,
        };
        this.$store.dispatch('pipelines/FilterContact', data);
      }
    },
    toggleCustomDate() {
      // this.showCustomDate = false; // Toggle modal visibility
      this.showCustomDate = !this.showCustomDate;
    },
    hideMorestate() {
      this.showMoreState = false;
    },
    hideMoreboard() {
      this.showMoreBoard = false;
    },
    onDateUpdate({ scheduledAtFrom, scheduledAtTo }) {
      // Format the dates to "DD-MM-YYYY"
      const formattedFrom = this.formatDate(scheduledAtFrom);
      const formattedTo = this.formatDate(scheduledAtTo);
      this.customDate = `${formattedFrom} - ${formattedTo}`; // Format the string for display

      console.log('Custom date selected:', formattedFrom, formattedTo); // Log the formatted custom dates

      // Update the component's state
      this.scheduledAtFrom = formattedFrom;
      this.scheduledAtTo = formattedTo;

      // Prepare the data object with the formatted dates and filters
      const data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key2: 'start_date',
        value2: this.scheduledAtFrom, // The formatted start date
        key3: 'end_date',
        value3: this.scheduledAtTo, // The formatted end date
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
      };

      console.log('Date with filters:', data); // Log the final data object

      // Dispatch the store action with the prepared data
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    // formatDate(date) {
    //   // Split the date into year, month, and day
    //   const [year, month, day] = date.split('-');

    //   // Return the date in "DD-MM-YYYY" format
    //   return `${day}-${month}-${year}`;
    // },
    formatDate(date) {
      // Check if the date is valid and properly formatted
      if (!date || typeof date !== 'string' || !date.includes('-')) {
        console.error('Invalid date provided:', date);
        return 'Invalid date';
      }

      // Split the date into year, month, and day
      const [year, month, day] = date.split('-');

      // Return in the desired format "DD-MM-YYYY"
      return `${day}-${month}-${year}`;
    },

    checkMove(e) {
      window.console.log('Future index: ' + e.draggedContext.futureIndex);
    },
    softReloadPage() {
      this.$router.go(0);
    },
    openAssignee() {
      this.showAssignee = !this.showAssignee;
    },
    toggleAssignee({ id, assignee }) {
      console.log('Assignee id', id, assignee);
      this.currentAssigneedata = assignee;
      this.currentAssignee = id;
      this.showAssignee = false;
      let data = {
        key: 'state_id',
        value: this.selectedState, // The state filter
        key1: 'name',
        value1: this.searchQuery, // The name filter
        key4: 'board_id',
        value4: this.selectedBoard,
        key5: 'assignee_id',
        value5: this.currentAssignee,
        key6: 'source_id',
        value6: this.selectedSource,
      };

      // Normalize filterMonths value (e.g., replacing spaces with underscores)
      const normalizedFilter = this.filterMonths?.replace(/\s+/g, '_');

      if (normalizedFilter) {
        switch (normalizedFilter) {
          case 'last_week':
            data.key2 = 'last_week';
            data.value2 = this.filterMonths;
            break;
          case 'last_month':
            data.key2 = 'last_month';
            data.value2 = this.filterMonths;
            break;
          case 'last_six_months':
            data.key2 = 'last_six_months';
            data.value2 = this.filterMonths;
            break;
          default:
            console.warn('Unknown filterMonths value:', this.filterMonths);
            break;
        }
      } else {
        data.key2 = 'start_date';
        data.value2 = this.scheduledAtFrom; // The start date filter
        data.key3 = 'end_date';
        data.value3 = this.scheduledAtTo; // The end date filter
      }
      this.$store.dispatch('pipelines/FilterContact', data);
    },
    hideAssignee() {
      this.showAssignee = false;
    },
    toggleDropdown(dropdownName) {
      bus.$emit('toggle-pipeline-dropdown');
      this.showAssignee = false;
      this.openDropdown =
        this.openDropdown === dropdownName ? null : dropdownName;
    },
    backUrl() {
      this.$router.push({ name: 'settings_account_reports' });
    },
    closeAlldraggable() {
      this.showAssignee = false;
      this.openDropdown = null;
    },
    updateLeadCount() {
      setTimeout(() => {
        this.totalLeadCount = this.$refs.newPipeline.totalContactsCount;
      },200);
    },
    boardName() {
      const boardId = this.$route.params.board_id;
      if (!boardId) {
        return this.$t('SIDEBAR.PIPELINES');
      }
      const board = this.boards.find(b => b.id === parseInt(boardId));
      return board ? board.name : 'Default Board';
    },
  },
};
</script>

<style  lang="scss" scoped>
.no-padding {
  padding: 0px !important;
}
.w-100 {
  width: 100%;
}
.w-40 {
  width: 40%;
}
.w-60 {
  width: 60%;
}
.pipeline {
  align-items: center;
}
.pipeline-filter-date {
  margin: 0px;
}
.filter-input >>> input {
  margin: unset;
}
.pipeline-dropdown {
  margin: 0px;
}

.filter-box {
  gap: 10px;
  align-items: center;
}
.input-search {
  flex: 1;
}
.pipeline-container {
  overflow-x: auto; /* Enable horizontal scrolling */
  background: #c9c7c729;
  height: 100%;
}
body.dark .pipeline-container {
  background-color: hsl(198 6.6% 15.8% / 1);
  overflow-x: auto;
  height: 93%;
}
.search-icon {
  margin-right: 8px; /* Adjust as needed */
  position: absolute;
  color: lightgray;
  right: 9px;
  top: 10px;
  z-index: 99;
}
.calendar-icon {
  margin-right: 8px; /* Adjust as needed */
  position: absolute;
  right: 22px;
  top: 10px;
  z-index: 99;
}
.new-color {
  color: #989898;
  font-size: 14px;
}
.pipeline-filter-select {
  margin: unset;
  padding-left: 27px;
}
.grey-color {
  color: lightgrey;
}
.search-wrap {
  .contact-search {
    font-size: 14px;
    padding: 21px 5px;
    border: 1px solid #ccc;
    @apply w-full h-[2.375rem] m-0;
  }

  .button {
    transition: transform 100ms linear;
    @apply ml-2 h-8 right-1 absolute py-0 px-2 opacity-0 -translate-x-px invisible;
  }

  .button.show {
    @apply opacity-100 translate-x-0 visible;
  }
}
.assignee-img {
  position: absolute;
  display: flex;
  top: 10px;
  left: 30%;
}
.assignee-list {
  position: absolute;
  z-index: 9;
}
.assignee-user {
  position: sticky;
}
.empty-assignee {
  width: 251px;
  height: 65px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  opacity: 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: large;
}
.date {
  position: relative;
  bottom: 10px;
}
.calendar {
  position: relative;
  top: 30px;
  padding-left: 4px;
  display: ruby;
}
.search-icon-data {
  position: relative;
  right: 26px;
  background-color: #ffffff;
}
.grey-color {
  color: #6b6b6b;
}
</style>